import * as API from '@/API';

function clearBulkSessions(path: string): void {
    const containsBulk = /[?&]Bulk=true/.test(path);

    const matchType = /[?&]Type=(\d+)/.exec(path);
    const typeValue = matchType ? matchType[1] : null;

    if (containsBulk && typeValue != null) {
        void API.bulkSession.clearBulkSession(+typeValue);
    }
}

const bulkSessionHelper = {
    clearBulkSessions,
};

export default bulkSessionHelper;
